import { createContext, useContext, useCallback, useState, type ReactNode } from "react";

interface AnnouncerContextValue {
  announce: (message: string, politeness?: "polite" | "assertive") => void;
}

const AnnouncerContext = createContext<AnnouncerContextValue>({
  announce: () => {},
});

export const useAnnounce = () => useContext(AnnouncerContext);

export function AnnouncerProvider({ children }: { children: ReactNode }) {
  const [politeMsg, setPoliteMsg] = useState("");
  const [assertiveMsg, setAssertiveMsg] = useState("");

  const announce = useCallback(
    (message: string, politeness: "polite" | "assertive" = "polite") => {
      const setter = politeness === "assertive" ? setAssertiveMsg : setPoliteMsg;
      setter("");
      setTimeout(() => setter(message), 50);
    },
    [],
  );

  return (
    <AnnouncerContext.Provider value={{ announce }}>
      {children}
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {politeMsg}
      </div>
      <div aria-live="assertive" aria-atomic="true" className="sr-only">
        {assertiveMsg}
      </div>
    </AnnouncerContext.Provider>
  );
}
